/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copy_Disabled_TitleInputs */



/**
* | output |
* | --- |
* | "Compliance must be enabled to copy patterns." |
*
* @param {Compliance_Copy_Disabled_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copy_disabled_title = /** @type {((inputs?: Compliance_Copy_Disabled_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copy_Disabled_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance muss aktiviert sein, um Muster zu kopieren.")
	return /** @type {LocalizedString} */ ("Compliance must be enabled to copy patterns.")
});